(() => {
  const initializeKlaviyo = () => {
    window.klaviyo = window.klaviyo || [];
    if (typeof window.klaviyo.init !== 'function' || typeof window.klaviyo.enable !== 'function') return false;

    window.klaviyo.init({
      account: 'Rre4UT',
      list: 'Vz4Sfs',
      platform: 'shopify',
    });

    window.klaviyo.enable('backinstock', {
      trigger: {
        product_page_text: 'Join Waitlist',
        product_page_class: 'klaviyo-bis-trigger',
        product_page_text_align: 'center',
        product_page_margin: '0px',
        replace_anchor: true,
      },
      modal: {
        headline: '{product_name}',
        body_content: 'Register to receive a notification when this item comes back in stock.',
        email_field_label: 'Email',
        button_label: 'Join Waitlist',
        subscription_success_label: "You're in! We'll let you know when it's back.",
        footer_content: '',
        additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
        drop_background_color: '#000',
        background_color: '#fff',
        text_color: '#222',
        button_text_color: '#fff',
        button_background_color: '#000',
        close_button_color: '#ccc',
        error_background_color: '#fcd6d7',
        error_text_color: '#c72e2f',
        success_background_color: '#f4f4fb',
        success_text_color: '#000',
      },
    });

    return true;
  };

  const loadKlaviyoBackInStock = () => {
    if (document.querySelector('[data-kitteny-klaviyo-bis-loader]')) return;

    const script = document.createElement('script');
    script.src = 'https://a.klaviyo.com/media/js/onsite/onsite.js';
    script.dataset.kittenyKlaviyoBisLoader = 'true';
    script.addEventListener('load', initializeKlaviyo, { once: true });
    document.head.appendChild(script);
  };

  // Shopify's Klaviyo app loader is asynchronous. Load the legacy back-in-stock
  // API after all app scripts have settled so it cannot be replaced afterward.
  if (document.readyState === 'complete') loadKlaviyoBackInStock();
  else window.addEventListener('load', loadKlaviyoBackInStock, { once: true });

  const setState = (actions, variant) => {
    if (!variant) return;
    const addToCart = actions.querySelector('[data-kitteny-add-to-cart]');
    const waitlist = actions.querySelector('[data-kitteny-waitlist]');
    if (!addToCart || !waitlist) return;

    addToCart.hidden = !variant.available;
    waitlist.hidden = variant.available;
    waitlist.dataset.variantId = String(variant.id || '');
    waitlist.dataset.variant = variant.title || '';
    waitlist.dataset.sku = variant.sku || '';
  };

  const setupActions = (root = document) => {
    root.querySelectorAll('[data-kitteny-product-actions]:not([data-kitteny-ready])').forEach((actions) => {
      actions.dataset.kittenyReady = 'true';

      actions.addEventListener('click', (event) => {
        const waitlist = event.target.closest('[data-kitteny-waitlist]');
        if (!waitlist) return;
        const form = actions.closest('product-form-component')?.querySelector('form') || actions.closest('form');
        const variantId = form?.querySelector('[name="id"]')?.value;
        if (variantId) waitlist.dataset.variantId = variantId;
        waitlist.dataset.productUrl = `${window.location.pathname}${window.location.search}`;
      }, true);
    });
  };

  document.addEventListener('shopify:product:select', async (event) => {
    const actions = event.target?.closest('product-form-component')?.querySelector('[data-kitteny-product-actions]');
    if (!actions || !event.promise) return;

    try {
      const result = await event.promise;
      setState(actions, result?.detail?.resource);
    } catch (_error) {
      // Atelier handles failed variant requests; keep the last confirmed state.
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupActions());
  else setupActions();

  document.addEventListener('shopify:section:load', (event) => setupActions(event.target));
})();
